import React from 'react';
import { CloseButton } from '@components/CloseButton';
import { MegaMenuStateProvider } from './MegaMenuState';
import './MegaMenuMain.scss';
import { MegaMenuNavigation } from './MegaMenuNavigation';
import { MegaMenuSegment } from '@layouts/MegaMenu/MegaMenu.types';

interface MegaMenuMainProps {
  show: boolean;
  selected: string;
  megaMenuColumns: {
    [key: string]: MegaMenuSegment;
  };
  closeMegaMenu: () => void;
}

const MegaMenuMain = ({ show, selected, megaMenuColumns, closeMegaMenu }: MegaMenuMainProps) => {
  const LEVELS = 4;
  const selectedColumn = megaMenuColumns[selected];

  return show ? (
    <div className='l-megaMenu-new'>
      <div className='l-megaMenu-container-new'>
        <CloseButton onClick={closeMegaMenu} />
        <MegaMenuStateProvider selectedSection={selected} megaMenuData={selectedColumn}>
          <MegaMenuNavigation levels={LEVELS} />
        </MegaMenuStateProvider>
      </div>
    </div>
  ) : null;
};

export default MegaMenuMain;
